import axios from "../axios";

export const warehouseStockApi = {
  getStock: async (params = {}) => {
    const response = await axios.get(`/inventory/warehouse_stock`, { params });
    return response.data;
  },

  getProductStock: async (productId, params = {}) => {
    const response = await axios.get(`/inventory/warehouse_stock/products/${productId}`, { params });
    return response.data;
  },

  getProductStockReport: async (productId, params = {}) => {
    const response = await axios.get(`/inventory/warehouse_stock/products/${productId}/report`, { params });
    return response.data;
  },
};


